import { Component, Input, OnChanges, SimpleChanges, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DyeingColor } from '../../../models/item/lab-dip';
import { CustomerProductOrders } from '../../../models/order/work-order';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-color-details-card',
  templateUrl: './color-details-card.component.html',
  styleUrl: './color-details-card.component.scss',
})
export class ColorDetailsCardComponent implements OnChanges {
  @Input() color: DyeingColor | null = null;
  @Input() garmentDetailsForm: FormGroup | null = null;
  @Input() uom = '';
  @Input() orderDetailsFormSubmitted = false;
  @Input() clientProductOrders: CustomerProductOrders[] = [];
  @Input() canEdit = false;
  clientProductOrderOptions: { label: string; value: string }[] = [];
  removeGarmentDetail = output<FormGroup>();

  constructor(
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clientProductOrders']) {
      this.clientProductOrderOptions = this.clientProductOrders.map((order) => ({
        label: order.productOrderNumber,
        value: order.productOrderNumber,
      }));
    }
  }

  removeColor() {
    this.confirmationService.confirm({
      message: this.translateService.instant('Work_Order_Details_Delete_Color_Alert'),
      header: this.translateService.instant('Common_Confirm'),
      icon: 'pi pi-exclamation-triangle',
      key: 'main',
      acceptLabel: this.translateService.instant('Delete'),
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: this.translateService.instant('Cancel'),
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        this.removeGarmentDetail.emit(this.garmentDetailsForm!);
      },
      reject: () => {
        return;
      },
    });
  }
}
